<kt-splash-screen *ngIf="loader"></kt-splash-screen>
<kt-loader-comp></kt-loader-comp>

<router-outlet></router-outlet>
